export default __webpack_public_path__ + "static/media/EVENT26A2R.452dc292.png";